/* eslint-disable no-console */

import { register } from 'register-service-worker';

// Uygulama versiyonu bilgisini global olarak sakla
window.APP_VERSION = process.env.APP_VERSION || '0.1.5';
window.APP_BUILD_TIME = process.env.BUILD_TIME || new Date().toISOString();

// Yeni versiyon kontrolü için özel fonksiyonlar
let refreshing = false;

// Tarayıcı uyumluluk kontrolü
const isServiceWorkerSupported = 'serviceWorker' in navigator;
const isHttps = window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const canUseServiceWorker = isServiceWorkerSupported && isHttps;

// Yeni sürüm kontrolü
async function checkForNewVersion() {
  try {
    // Query string ile cache busting yap
    const response = await fetch(`/app-version.json?t=${new Date().getTime()}`);
    if (!response.ok) return false;
    
    const data = await response.json();
    // Mevcut sürüm ile karşılaştır
    return data.version !== window.APP_VERSION;
  } catch (err) {
    console.error('Versiyon kontrol hatası:', err);
    return false;
  }
}

// Yeni versiyon mevcut olduğunda kullanıcıya bildirmek için olay
const appUpdateEvent = new Event('app-update-available');

if (process.env.NODE_ENV === 'production' && canUseServiceWorker) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      );
      
      // Sayfa yüklenince versiyon kontrolü yap
      setTimeout(async () => {
        const hasNewVersion = await checkForNewVersion();
        if (hasNewVersion) {
          window.dispatchEvent(appUpdateEvent);
        }
      }, 3000);
    },
    registered (registration) {
      console.log('Service worker has been registered.');
      
      // Düzenli olarak yeni versiyonları kontrol et
      setInterval(async () => {
        try {
          // Service Worker'i güncelle
          await registration.update();
          
          // Ayrıca app-version.json dosyasını kontrol et
          const hasNewVersion = await checkForNewVersion();
          if (hasNewVersion && !refreshing) {
            refreshing = true;
            window.dispatchEvent(appUpdateEvent);
          }
        } catch (err) {
          console.error('Güncelleme kontrol hatası:', err);
        }
      }, 1000 * 60 * 5); // Her 5 dakikada bir kontrol et
    },
    cached () {
      console.log('Content has been cached for offline use.');
    },
    updatefound () {
      console.log('New content is downloading.');
    },
    updated (registration) {
      console.log('New content is available; Please refresh.');
      
      // Yeni versiyon mevcut - kullanıcıya bildirim göndermek için
      if (!refreshing) {
        refreshing = true;
        window.dispatchEvent(appUpdateEvent);
      }
      
      // Yeni servis worker'a geçiş yapmasını söyle
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error (error) {
      console.error('Error during service worker registration:', error);
    }
  });
}

// Service worker mesajlarını dinle
if (navigator.serviceWorker) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'RELOAD_PAGE') {
      window.location.reload();
    }
  });
}

// App güncelleme olayını dışarı aç
// Bu sayede diğer bileşenler bu olayı dinleyebilirler
export { appUpdateEvent };
